import { render } from "./WDCView.vue?vue&type=template&id=02f6371e"
import script from "./WDCView.vue?vue&type=script&lang=js"
export * from "./WDCView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__